import { render, staticRenderFns } from "./TourneeDetails.vue?vue&type=template&id=a914995e&scoped=true&"
import script from "./TourneeDetails.vue?vue&type=script&lang=js&"
export * from "./TourneeDetails.vue?vue&type=script&lang=js&"
import style0 from "./TourneeDetails.vue?vue&type=style&index=0&id=a914995e&scoped=true&lang=css&"
import style1 from "./TourneeDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a914995e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!E:/projets/dotnet/GestionTournees/dev/GestionTourneesWeb/ClientApp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBottomSheet } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFabTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAlert,VBottomSheet,VBtn,VContainer,VContent,VFabTransition,VFlex,VIcon,VLayout,VSpacer,VToolbar,VToolbarTitle})


/* vuetify-loader */
import installDirectives from "!E:/projets/dotnet/GestionTournees/dev/GestionTourneesWeb/ClientApp/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Scroll } from 'vuetify/lib/directives'
installDirectives(component, {Scroll})
